<script lang="ts">
const __DsBlock = {
	type: 'display',
	name: '$t:blocks.display_boolean.name',
	description: '$t:blocks.display_boolean.description',
	icon: 'material-symbols:check-box-outline-rounded',
	category: 'display',
	hidden: true,

	fieldBinding: {
		supportedTypes: ['boolean'],
	},
}
</script>
<script setup lang="ts">
import type { DisplayBlockProps } from '~/types/display-block';

import { defineBlock } from '#layers/block-engine';

interface DisplayBooleanValueProps extends DisplayBlockProps<boolean> {}

defineProps<DisplayBooleanValueProps>();

;
</script>

<template>
	<div class="flex items-center">
		<DIcon :name="value ? 'lucide:check' : 'lucide:x'" :class="{ 'text-dimmed': !value }" />
	</div>
</template>
